import {
  GET_ALL_OPERATOR_PRODUCTS,
  GET_ALL_OPERATOR_PRODUCTS_RESPONSE_SUCCESS,
  CREATE_OPERATOR_PRODUCT,
  UPDATE_OPERATOR_PRODUCT,
  DELETE_OPERATOR_PRODUCT,
  GET_SPECIFIC_OPERATOR_PRODUCTS,
} from "./actionTypes"

export const getAllOperatorProducts = () => {
  return {
    type: GET_ALL_OPERATOR_PRODUCTS,
  }
}
export const getAllOperatorProductsResponseSuccess = payload => ({
  type: GET_ALL_OPERATOR_PRODUCTS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createOperatorProduct = (payload, history) => {
  return {
    type: CREATE_OPERATOR_PRODUCT,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateOperatorProduct = (payload, history, redirectTo) => {
  return {
    type: UPDATE_OPERATOR_PRODUCT,
    payload: payload,
    history,
    redirectTo,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteOperatorProduct = payload => ({
  type: DELETE_OPERATOR_PRODUCT,
  payload: payload,
})
